<prizm-doc-page class="info-page" header="Требования к библиотекам">
  <p>
    Требования которые необходимо соблюдать при вводе общих библиотек в платформу. Все требования основаны на
    том что у нас один контекст, одно окружение, одни общие ресурсы, один экран браузера.
  </p>
  <ol class="disc">
    <li>Изолированный контекст выполнений функции</li>
    <li>Изолированные ресурсы (шрифты, css, img)</li>
    <li>Общие ресурсы должны быть под версиями и не влиять на общий scope.</li>
  </ol>
  <p>Какие фреймворки/библиотеки/решения предоставляют из коробки, и пытаются решить эти требования:</p>

  <h4>Angular</h4>
  <ol class="disc">
    <li>
      <a href="https://angular.io/api/core/ViewEncapsulation#Emulated">ViewEncapsulation.Emulated</a> по
      умолчанию
    </li>
    <li>изоляция scope компонентов</li>
    <li>Нужно вводить ограничения чтобы не декларировать в глобальные области видимости ресурсы</li>
  </ol>

  <h4>React</h4>
  <ol class="disc">
    <li>CSS in JS</li>
    <li>изоляция scope компонентов</li>
    <li>Много подходов для написание стилей и холиваров по ним</li>
    <li>Ресурсы берутся всегда по разному, кучу loader по разному регистрируют свои ресурсы по разному</li>
    <li>-Нужно вводить ограничения чтобы не декларировать в глобальные области видимости ресурсы</li>
  </ol>

  <h4>Vue</h4>
  <ol class="disc">
    <li>Scoped css</li>
    <li>изоляция scope компонентов</li>
    <li>+/- приходят к стандартизации и изоляции на своих собственных сборщиках</li>
    <li>Нужно вводить ограничения чтобы не декларировать в глобальные области видимости ресурсы</li>
  </ol>

  <h4>Custom Elements, Shadow dom (lit-element, stencil, …)</h4>
  <ol class="disc">
    <li>Styles по дефолту изолированы из коробки</li>
    <li>можно писать на любом фреймворке и использовать их</li>
    <li>
      декларирует элементы в глобальном скоупе, и мы лишаемся версионирования и жестко привязываем версию либы
      ко всей платформе
    </li>
    <li>легко написать функцию в глобальной области видимости.</li>
    <li>
      в 2 раза медленее работают
      <a href="https://nolanlawson.com/2021/08/15/does-shadow-dom-improve-style-performance/"
        >https://nolanlawson.com/2021/08/15/does-shadow-dom-improve-style-performance/</a
      >
    </li>
    <li>сложно тестировать, доступ до элементов в e2e усложняется</li>
  </ol>

  <h4>Angular elements</h4>
  <ol class="disc">
    <li>Можно перевести КБ на кастомные элементы и начать юзать во всех фреймворках</li>
    <li>много весят</li>
    <li>проблемы из <strong>Custom Elements</strong></li>
  </ol>

  <h2>Краткий обзор по разным КБ, фреймворкам:</h2>
  <ol class="disc">
    <li><strong>Angular Material</strong> - хорош в плане изоляции стилей и легок для изменения.</li>
    <li>
      <strong>PrimeNG</strong> - был хорош для 2016, так как из JQuery слезали на него, но из за подхода
      декларировать в глобальном скоупе стили, имеет более 500 issue в GitHub, которые в принципе не будут
      исправлять. В платформе часто возникали вопросы про темизацию, и как все мешали друг другу.
    </li>
    <li>
      <strong>TaigaUI</strong> -с овременная UI библиотека на Angular, изоляция контекста и стилей на уровне.
    </li>
    <li>
      <strong>Stencil</strong> - фреймворк, продукт Ionic, которые решали свою проблему по созданию приложений
      на мобилку под разные фреймворки, отсюда и игнорирование ограничений.
    </li>
    <li>
      <strong>Clarity</strong> - UI библиотека на Angular, делает упор на Html+css first, отсюда и проблемы
      разных версии.
    </li>
    <li>
      <strong>Prizm</strong> - современная UI библиотека на Angular, учитывающий требования к платформе, под
      нашу дизайн-систему
    </li>
  </ol>
</prizm-doc-page>
